import { Link, useLocation } from "react-router-dom";
import { MessageCircle, CalendarHeart } from "lucide-react";

const HIDDEN_ON = ["/consultation", "/analytics", "/requests"];

export const MobileConversionBar = () => {
  const { pathname } = useLocation();
  const hidden = HIDDEN_ON.includes(pathname);
  return (
    <>
      {!hidden && <div className="h-[4.5rem] sm:hidden" aria-hidden="true" />}
      {!hidden && (
        <div
          data-testid="mobile-conversion-bar"
          className="fixed inset-x-0 bottom-0 z-40 flex gap-3 border-t border-[#A58343]/25 bg-[#262019]/95 px-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 backdrop-blur-xl sm:hidden"
        >
          <a
            href="https://wa.me/8801713044029"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-cta-whatsapp"
            className="flex flex-1 items-center justify-center gap-2 rounded-full border border-[#A58343]/60 py-3 text-[11px] uppercase tracking-[0.2em] text-[#FAF7F1] transition-colors duration-300 active:bg-[#A58343]/20"
          >
            <MessageCircle size={15} strokeWidth={1.5} />
            WhatsApp
          </a>
          <Link
            to="/consultation"
            data-testid="mobile-cta-consultation"
            className="flex flex-[1.4] items-center justify-center gap-2 rounded-full bg-[#A58343] py-3 text-[11px] font-medium uppercase tracking-[0.2em] text-[#262019] transition-colors duration-300 active:bg-[#8f7139]"
          >
            <CalendarHeart size={15} strokeWidth={1.5} />
            Book Consultation
          </Link>
        </div>
      )}
    </>
  );
};
